import { Injectable, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface BrandingConfig {
  label: string;
  logoUrl?: string;
  faviconUrl?: string;
  showLogo: boolean;
  theme: {
    background: string;
    text: string;
  };
}
@Injectable({ providedIn: 'root' })
export class BrandingService {
  private readonly _branding = signal<BrandingConfig | null>(null);
  readonly branding = computed(() => this._branding());

  constructor(private http: HttpClient) {}

  async load(): Promise<void> {
    const mode = this.detectMode(); // 'embedded' | 'standalone'
    const brandKey = environment.brandKey === '' ? 'necta' : environment.brandKey;
    const url = `assets/branding/${brandKey}/${mode}.json`;

    const cfg = await this.http.get<BrandingConfig>(url).toPromise();
    this._branding.set(cfg!);
    this.applyCssVars(cfg!);
    this.applyFavicon(cfg!);
  }

  private detectMode(): 'embedded' | 'standalone' {
    try { return window.self !== window.top ? 'embedded' : 'standalone'; }
    catch { return 'embedded'; }
  }

  private applyCssVars(cfg: BrandingConfig) {
    const root = document.documentElement;
    root.style.setProperty('--brand-background', cfg.theme.background);
    root.style.setProperty('--brand-font-color', cfg.theme.text);
  }

  private applyFavicon(cfg: BrandingConfig) {
  const href = cfg.faviconUrl ?? 'assets/branding/necta/favicon.ico';

  let link = document.querySelector<HTMLLinkElement>('#app-favicon');
  if (!link) {
    link = document.createElement('link');
    link.id = 'app-favicon';
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  const cacheBust = `v=${Date.now()}`;
  link.href = href.includes('?') ? `${href}&${cacheBust}` : `${href}?${cacheBust}`;
}
}